import { NETLIFY_FUNCTIONS_PATH } from '../utils/constants';

export async function fetchMilanStores() {
    // Dev: hit Firebase directly (no CDN locally). Prod/preview uses the cached function below.
    if (process.env.NODE_ENV === 'development') {
        const [{ collection, getDocs }, { db }] = await Promise.all([
            import('firebase/firestore'),
            import('../firebase/firebase'),
        ]);
        const collectionRef = collection(db, process.env.GATSBY_FIREBASE_MILAN_STORES_COLLECTION);
        const snapshot = await getDocs(collectionRef);
        return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    }

    const response = await fetch(`${NETLIFY_FUNCTIONS_PATH}milan-stores`);
    if (!response.ok) {
        // Include the function's { error } payload so the caller's log surfaces the root cause.
        const body = await response.text().catch(() => '');
        throw new Error(`milan-stores function responded with status ${response.status}: ${body}`);
    }
    return response.json();
}
